/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="pointPromotionCampaign.module.ts" />

module Meevo.Plugins.PointPromotionCampaign {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    class PointPromotionCampaignController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public objectState;

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
			'$translate'
        ];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $translate: angular.translate.ITranslateService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.objectState = ObjectStateEnum;
        }

        /**
         * Creates the context for editing/adding an item.
         * @return {}
         */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.MANAGEMENT_POINTPROMOTIONCAMPAIGN).then(() => {
                this.busyService.stop();
                this.context = new PointPromotionCampaignContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
	                this.$translate);
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
            }).finally(() => {
                this.busyService.stop();
            });
        }
    }


    angular.module("meevo.plugins.pointPromotionCampaign")
        .controller("meevo.plugins.pointPromotionCampaign.PointPromotionCampaignController", PointPromotionCampaignController);
}